import React, { useState } from 'react';
import pb from '../../lib/pocketbase';
import './Contact.css';

const Contact = ({ agencySettings }) => {
    const DEFAULT_MAP_SRC = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2889.31758661642!2d1.4116538!3d43.59995119999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12aebb626998fc0d%3A0x673995804593f6b!2s123%20Av.%20de%20Grande%20Bretagne%2C%2031300%20Toulouse!5e0!3m2!1sfr!2sfr!4v1714578120000!5m2!1sfr!2sfr";
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        subject: 'Devis',
        message: ''
    });
    const [sending, setSending] = useState(false);
    const [success, setSuccess] = useState(false);

    const companyName = agencySettings?.company_name || "L'Univers Diag";
    const phone = agencySettings?.phone_public || "07 58 04 43 77";
    const email = agencySettings?.email_public || "contact@luniversdiag.fr";
    const address = agencySettings?.address_office || "123 Avenue de Grande Bretagne, Toulouse - Sur RDV";
    const socials = agencySettings?.socials ? (typeof agencySettings.socials === 'string' ? JSON.parse(agencySettings.socials) : agencySettings.socials) : {};

    const handleSendMessage = async (e) => {
// ... (omitted)
        e.preventDefault();
        setSending(true);
        
        // Split name into first and last
        const nameParts = formData.name.trim().split(' ');
        const fName = nameParts[0] || '';
        const lName = nameParts.slice(1).join(' ') || '';

        try {
            await pb.collection('messages').create({
                firstName: fName,
                lastName: lName,
                email: formData.email,
                phone: formData.phone,
                subject: formData.subject,
                message: formData.message,
                status: 'new'
            });
            setSuccess(true);
            setFormData({ name: '', email: '', phone: '', subject: 'Devis', message: '' });
            setTimeout(() => setSuccess(false), 5000);
        } catch (err) {
            console.error(err);
            alert("Erreur lors de l'envoi. Veuillez réessayer.");
        } finally {
            setSending(false);
        }
    };

    return (
        <div className="contact-page-container">
            <header className="contact-hero">
                <h2>Contactez {companyName}</h2>
                <p>
                    {agencySettings?.description_short || "Une question technique ? Une demande spécifique ? Notre équipe d'experts est à votre écoute pour vous accompagner dans vos projets d'ingénierie et de maintenance automobile."}
                </p>
            </header>

            <div className="contact-grid">
                <section className="contact-form-card">
                    <h3>✉️ Envoyez-nous un message</h3>
                    <form className="contact-form" onSubmit={handleSendMessage}>
                        <div className="form-row grid-2">
                            <div className="form-item">
                                <label className="form-label-title">Nom / Prénom</label>
                                <input 
                                    type="text" 
                                    placeholder="Votre nom" 
                                    className="custom-input" 
                                    required
                                    value={formData.name}
                                    onChange={(e) => setFormData({...formData, name: e.target.value})}
                                />
                            </div>
                            <div className="form-item">
                                <label className="form-label-title">E-mail</label>
                                <input 
                                    type="email" 
                                    placeholder="votre@email.fr" 
                                    className="custom-input" 
                                    required
                                    value={formData.email}
                                    onChange={(e) => setFormData({...formData, email: e.target.value})}
                                />
                            </div>
                        </div>

                        <div className="form-row grid-2" style={{ marginTop: '1.5rem' }}>
                            <div className="form-item">
                                <label className="form-label-title">Téléphone</label>
                                <input 
                                    type="tel" 
                                    placeholder="06 00 00 00 00" 
                                    className="custom-input" 
                                    value={formData.phone}
                                    onChange={(e) => setFormData({...formData, phone: e.target.value})}
                                />
                            </div>
                            <div className="form-item">
                                <label className="form-label-title">Sujet</label>
                                <select 
                                    className="custom-input" 
                                    value={formData.subject}
                                    onChange={(e) => setFormData({...formData, subject: e.target.value})}
                                >
                                    <option value="Devis">Demande de Devis</option>
                                    <option value="Rendez-vous">Prise de Rendez-vous</option>
                                    <option value="Partenariat">Partenariat</option>
                                    <option value="Autre">Autre demande</option>
                                </select>
                            </div>
                        </div>
                        <div className="form-item" style={{ marginTop: '1.5rem' }}>
                            <label className="form-label-title">Message</label>
                            <textarea 
                                rows={6} 
                                placeholder="Comment pouvons-nous vous aider ?" 
                                className="custom-input custom-textarea" 
                                required
                                value={formData.message}
                                onChange={(e) => setFormData({...formData, message: e.target.value})}
                            />
                        </div>
                        
                        {success ? (
                            <div className="success-banner" style={{ marginTop: '1rem', padding: '1rem', background: '#dcfce7', color: '#166534', borderRadius: '12px', textAlign: 'center' }}>
                                ✨ Message envoyé avec succès ! Nous vous répondrons très bientôt.
                            </div>
                        ) : (
                            <button className="hero-cta full-width" style={{ marginTop: '2rem' }} disabled={sending}>
                                {sending ? 'Envoi en cours...' : 'Transmettre ma demande'}
                            </button>
                        )}
                    </form>
                </section>

                <aside className="contact-info-stack">
                    <div className="info-box">
                        <h4>📍 Localisation</h4>
                        <div className="info-content">
                            <strong>Siège Social</strong>
                            {agencySettings?.maps_link ? (
                                <a 
                                    href={agencySettings.maps_link} 
                                    target="_blank" 
                                    rel="noopener noreferrer" 
                                    className="address-link-premium"
                                >
                                    {address}
                                </a>
                            ) : address}
                        </div>
                    </div>

                    <div className="info-box">
                        <h4>📞 Direct</h4>
                        <div className="info-content">
                            <strong>Service technique</strong>
                            {phone}<br />
                            <strong>Email</strong>
                            {email}
                        </div>
                    </div>

                    <div className="info-box">
                        <h4>🕒 Horaires</h4>
                        <div className="info-content">
                            {(() => {
                                // 1. Real-time Status Check
                                let statusLine = null;
                                if (agencySettings?.busy_mode_active || agencySettings?.closure_banner_active) {
                                    statusLine = <div className="status-badge closed" style={{ marginBottom: '1rem' }}>⚠️ INDISPONIBLE</div>;
                                } else {
                                    try {
                                        const now = new Date();
                                        const dayNamesArr = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
                                        const h = agencySettings?.opening_hours ? (typeof agencySettings.opening_hours === 'string' ? JSON.parse(agencySettings.opening_hours) : agencySettings.opening_hours) : null;
                                        const daySet = h ? h[dayNamesArr[now.getDay()]] : null;

                                        if (daySet && daySet.open && daySet.start && daySet.end) {
                                            const [sh, sm] = daySet.start.split(':').map(Number);
                                            const [eh, em] = daySet.end.split(':').map(Number);
                                            const curr = now.getHours() * 60 + now.getMinutes();
                                            if (curr >= (sh * 60 + sm) && curr < (eh * 60 + em)) {
                                                statusLine = <div className="status-badge open" style={{ marginBottom: '1rem' }}>● OUVERT ACTUELLEMENT</div>;
                                            } else {
                                                statusLine = <div className="status-badge closed" style={{ marginBottom: '1rem' }}>● FERMÉ ACTUELLEMENT</div>;
                                            }
                                        } else {
                                            statusLine = <div className="status-badge closed" style={{ marginBottom: '1rem' }}>● FERMÉ ACTUELLEMENT</div>;
                                        }
                                    } catch (e) { /* ignore */ }
                                }

                                if (!agencySettings?.opening_hours) return (
                                    <>
                                        {statusLine}
                                        <strong>Lundi - Vendredi</strong> 10h00 - 19h00<br />
                                        <strong>Samedi</strong> 10h00 - 16h00
                                    </>
                                );

                                const h = typeof agencySettings.opening_hours === 'string' ? JSON.parse(agencySettings.opening_hours) : agencySettings.opening_hours;
                                const joursMap = {
                                    monday: 'Lundi', tuesday: 'Mardi', wednesday: 'Mercredi', 
                                    thursday: 'Jeudi', friday: 'Vendredi', saturday: 'Samedi', sunday: 'Dimanche'
                                };
                                
                                return (
                                    <>
                                        {statusLine}
                                        <div className="hours-list-detailed">
                                            {Object.entries(joursMap).map(([key, label]) => {
                                                // Harmonize fallbacks with Footer
                                                let defaultData = { open: true, start: '09:00', end: '18:30' };
                                                if (key === 'saturday') defaultData = { open: true, start: '09:00', end: '12:30' };
                                                if (key === 'sunday') defaultData = { open: false, start: '00:00', end: '00:00' };

                                                const dayData = h[key] || defaultData;
                                                
                                                if (key === 'sunday' && !dayData.open) return null; // Skip Sunday if closed
                                                return (
                                                    <div key={key} className="hour-row-item">
                                                        <strong>{label}</strong>
                                                        <span>{dayData.open ? `${dayData.start.replace(':', 'h')} - ${dayData.end.replace(':', 'h')}` : 'Fermé'}</span>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </>
                                );
                            })()}
                        </div>
                    </div>

                    <div className="info-box">
                        <h4>🔗 Réseaux Sociaux</h4>
                        <div className="socials-row">
                            {Object.entries(socials).map(([platform, url]) => (
                                url && <a key={platform} href={url} target="_blank" rel="noopener noreferrer" className="social-pill capitalize">{platform}</a>
                            ))}
                        </div>
                    </div>
                </aside>
            </div>

            <section className="contact-map-card">
                <iframe
                    src={agencySettings?.maps_link?.includes('maps/embed') 
                        ? agencySettings.maps_link 
                        : DEFAULT_MAP_SRC}
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title={`Localisation ${companyName}`}
                ></iframe>
            </section>
        </div>
    );
};

export default Contact;
